<h2 mat-dialog-title>{{ 'administration.sync-monitoring.replay-dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.reset-dialog.environment' | translate }}:</span>
		<strong>{{ data.environmentName }}</strong>
	</p>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.reset-dialog.scope' | translate }}:</span>
		<strong>{{ data.table.tableName }}</strong>
	</p>
	<p class="audit-dialog-note">{{ 'administration.sync-monitoring.replay-dialog.description' | translate }}</p>

	@if (isLoading && ready.length === 0 && blocked.length === 0) {
		<mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
	} @else {
		<table class="audit-dialog-table">
			<thead>
				<tr>
					<th>{{ 'administration.sync-monitoring.tables.columns.name' | translate }}</th>
					<th class="audit-dialog-num">{{ 'administration.sync-monitoring.replay-dialog.skipped' | translate }}</th>
					<th class="audit-dialog-num">{{ 'administration.sync-monitoring.replay-dialog.will-send' | translate }}</th>
				</tr>
			</thead>
			<tbody>
				@for (table of ready; track table.tableName) {
					<tr>
						<td>{{ table.tableName }}</td>
						<td class="audit-dialog-num">{{ table.skipped ?? '—' }}</td>
						<td class="audit-dialog-num">
							<strong>{{ table.willSendAtMost ?? '—' }}</strong>
						</td>
					</tr>
				} @empty {
					<tr>
						<td colspan="3">{{ 'administration.sync-monitoring.replay-dialog.nothing' | translate }}</td>
					</tr>
				}
			</tbody>
		</table>
		@for (table of blocked; track table.tableName) {
			<div class="audit-dialog-warning">
				<strong>{{ table.tableName }}</strong>
				{{ 'administration.sync-monitoring.replay-dialog.blocked.' + table.blockedReason | translate }}
			</div>
		}
		<p class="audit-dialog-note">{{ 'administration.sync-monitoring.replay-dialog.superseded-note' | translate }}</p>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" [disabled]="isLoading && ready.length > 0" (click)="onCancel()">
		{{ 'general.cancel' | translate }}
	</button>
	<button mat-flat-button color="primary" type="button" [disabled]="isLoading || ready.length === 0" (click)="onReplay()">
		@if (isLoading && ready.length > 0) {
			<mat-progress-spinner diameter="18" mode="indeterminate" class="audit-dialog-spinner"></mat-progress-spinner>
		}
		{{ 'administration.sync-monitoring.replay-dialog.confirm' | translate: { count: willSendAtMost } }}
	</button>
</mat-dialog-actions>
